const findDivisibleWidth = (width, histogramLength) => {
  // nutno počítat se (sloupce-1) mezer, které musí mít alespoň 1px
  let divisibleWidth = width - histogramLength - 1;
  while (divisibleWidth > 0) {
    if ((divisibleWidth / histogramLength) % 1 === 0) return divisibleWidth;
    divisibleWidth -= 1;
  }
  return width;
};

const roundNumber = (number, decimals) => Math.ceil((number + Number.EPSILON) * (10 ** decimals)) / (10 ** decimals);

export const makeHistogram = (
  { histogramHeight, disabled },
  { values },
  histogram, histogramLength, width, maxYValue, decimals, { min, max },
) => {
  // musíme najít největší šířku dělitelnou počtem sloupců - šířka celé pixely, zbytek se rozdělí mezi mezery
  const divisibleWidth = findDivisibleWidth(width, histogramLength);
  const singleDivWidth = divisibleWidth / histogramLength;
  const borderWidth = (width - divisibleWidth) / histogramLength;

  // scaling
  const range = max - min;
  // range 100-250, 10 points: left point of 0 is 100, 1 is 115..., we need the left point
  const scale = (col) => min + (range / histogramLength) + ((range / histogramLength) * col);
  const histoDivs = histogram.map((point, idx, histo) => {
    const columnHeight = (point[2] / maxYValue) * 100;
    const adjustedColumnHeight = (columnHeight / 100) * histogramHeight;
    const stateClass = (
      ((histo[idx - 1] && roundNumber(scale(histo[idx - 1][0]), decimals) >= values.min) || values.min === min) &&
      ((roundNumber(scale(point[0]), decimals) <= values.max) || values.max === max) &&
      !disabled
    )
      ? 'range-slider__histo-column--enabled'
      : 'range-slider__histo-column--disabled';
    return `<div
      class="range-slider__histo-column ${stateClass}"
      style="height: ${adjustedColumnHeight}px; left: ${(singleDivWidth + borderWidth) * (point[0])}px; width: ${singleDivWidth}px;">
      </div>`;
  });
  return histoDivs.join('');
};

export default makeHistogram;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RangeSlider/histogram.js